export default Object.freeze({
  EMAIL: "email",
  CALL: "call",
  VIDEO: "video",
});
